<template>
  <div>
    <v-row no-gutters class="mx-2 mt-2">
      <v-col cols="4" class="d-flex px-4 justify-center align-center">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Recherche par titre"
          color="third"
          @input="filteredSessions()"
        />
      </v-col>
      <v-col cols="4" class="d-flex px-4 justify-center align-center">
        <v-btn class=" justify-center align-center third white--text" @click="openDateDialog">{{ dateStr }}</v-btn>
        <v-dialog v-model="dateDialog" class="pa-0" width="290">
          <v-card class="d-flex flex-column align-end pa-0">
            <v-card-text class="d-flex justify-center pa-0">
              <v-date-picker
                v-model="picker"
                :min="minDate"
                :max="maxDate"
                :show-week="true"
                :first-day-of-week="1"
                range
                color="third"
              />
            </v-card-text>
            <v-card-actions class="flex-grow-1 justify-end">
              <v-btn class="third--text" text @click="closeDateDialog">Cancel</v-btn>
              <v-btn class="third--text" text @click="pickDate">Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="4" class="d-flex px-4 justify-center align-center">
        <v-select
          v-model="filterByInstructor"
          multiple
          label="Filtrer par moniteur"
          :items="everyInstructor"
          item-text="fullname"
          item-value="uuid"
          return-object
          color="third"
          item-color="third"
          @input="filteredSessions()"
        />
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="filteredSessions()"
      :height="tableHeight"
    >
      <template #item.observation="{ item }">
        <v-icon v-if="item.observation" @click="openObsDialog(item)">mdi-text-box-outline</v-icon>
        <p v-else>--</p>
      </template>
    </v-data-table>
    <v-dialog v-model="obsDialog" width="500">
      <v-card>
        <v-card-title class="third d-flex justify-center white--text">Session : {{ selectedSession.title }}</v-card-title>
        <v-card-text class="mt-4">
          {{ selectedSession.observation }}
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn class="third--text" text @click="closeObsDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import { endOfDay, format, fromUnixTime, startOfDay, parseISO, endOfWeek, startOfWeek, addDays, isAfter } from 'date-fns';
// import { getSessionsByPeriod } from '@/helpers/amplify';
import { fr } from 'date-fns/esm/locale';
import { filterSessionByInterval } from '@/helpers/sessions';

import store from '@/store';

export default {
  setup () {
    const search = ref(null);
    const filterByInstructor = ref([]);
    const everyInstructor = ref([]);
    const dateDialog = ref(false);
    const obsDialog = ref(false);
    const selectedSession = ref({});
    const picker = ref([format(new Date(), 'yyyy-MM-dd'), format(addDays(endOfWeek(new Date()), 1), 'yyyy-MM-dd')]);
    const selectedDateRange = ref([]);
    const tableHeight = computed(() => window.innerHeight * 0.75);

    const weeklySessions = ref(store.state.sessions);
    // const sessions = ref(store.getters.dailySessions);
    // const workspace = computed(() => store.getters.amplifyWorkspace);

    const minDate = computed(() => (format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd')));
    const maxDate = computed(() => format(addDays(endOfWeek(new Date()), 1), 'yyyy-MM-dd'));

    const headers = [
      { text: 'Titre de la session', value: 'title', align: 'center', width: '35%' },
      { text: 'Date de la session (Heure de début)', value: 'date', align: 'center', width: '20%' },
      { text: 'Moniteur(s)', value: 'instructor', align: 'center', width: '35%' },
      { text: 'Observation', value: 'observation', align: 'center', width: '10%' }
    ];

    const getInstructors = session => {
      // construir um array com o nome de todos os instrutores para apresentar no v-select
      const instructors = [];
      session.instructors.map(instr => {
        const instructor = store.getters.instructor(instr.uuid);
        if (instructor) {
          everyInstructor.value.push(instructor);
          instructors.push(instructor);
        }
      });
      return instructors;
    };

    const summaryData = computed(() => (
      weeklySessions.value.map(session => {
        const allInstructorsInSession = getInstructors(session);
        return {
          title: session.name,
          date: format(fromUnixTime(session.start_time), 'dd-MM-yyyy (EEEE - kk:mm)', { locale: fr }),
          instructor: allInstructorsInSession.length > 0 ? allInstructorsInSession.map(instructor => instructor.fullname).join(', ') : '--',
          instructorsArray: allInstructorsInSession,
          observation: session.observation
        };
      })
    ));

    const filteredSessions = () => {
      if (!search.value && !filterByInstructor.value) {
        return summaryData.value;
      }
      return summaryData.value.filter(session => {
        const titleMatch = !search.value || session.title.toLowerCase().includes(search.value.toLowerCase());
        const instructorMatch = filterByInstructor.value.length === 0 || filterByInstructor.value.some(selectedInstructor => session.instructorsArray.some(sessionInstructor => sessionInstructor.uuid === selectedInstructor.uuid));

        return titleMatch && instructorMatch;
      });
    };

    const pickDate = async () => {
      selectedDateRange.value = picker.value.sort((a, b) => (isAfter(new Date(a), new Date(b)) ? 1 : -1));

      let start = null;
      let end = null;
      if (selectedDateRange.value.length) {
        start = startOfDay(parseISO(selectedDateRange.value[0]));
        end = endOfDay(parseISO(selectedDateRange.value[1]));
      } else {
        start = startOfDay(parseISO(selectedDateRange.value[0]));
        end = endOfDay(parseISO(selectedDateRange.value[0]));
      }
      weeklySessions.value = store.state.sessions;
      weeklySessions.value = filterSessionByInterval(weeklySessions.value, start, end);
      // weeklySessions.value = await getSessionsByPeriod(start, end, workspace.value);
      // filteredSessions();
      dateDialog.value = false;
    };

    const dateStr = computed(() => {
      switch (selectedDateRange.value.length) {
        case 1:
          return `${selectedDateRange.value[0]}`;
        case 2: {
          const start = selectedDateRange.value[0];
          const end = selectedDateRange.value[1];
          return `${start} - ${end}`;
        }
        default:
          return 'Sélectionner une plage de dates';
      }
    });

    const openDateDialog = () => {
      dateDialog.value = true;
    };
    const closeDateDialog = () => {
      dateDialog.value = false;
    };

    const openObsDialog = session => {
      selectedSession.value = session;
      obsDialog.value = true;
    };
    const closeObsDialog = () => {
      obsDialog.value = false;
    };

    return { minDate, maxDate, selectedSession, closeObsDialog, openObsDialog, obsDialog, getInstructors, dateStr, pickDate, picker, dateDialog, openDateDialog, closeDateDialog, filterByInstructor, everyInstructor, filteredSessions, search, summaryData, weeklySessions, headers, tableHeight };
  }
};
</script>
